module.exports = __webpack_public_path__ + "img/logo.80914bf7.png";